var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewinvoice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Path_38832",
    x: 30.492,
    y: 11.839,
    width: 9.677,
    height: 9.675,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "New_invoice",
    "data-name": "New invoice",
    transform: "translate(-1043.518 -967.263)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38828",
    "data-name": "Path 38828",
    d: "M26,0A26,26,0,1,1,0,26,26,26,0,0,1,26,0",
    transform: "translate(1043.518 967.263)",
    fill: "#56aa1c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38829",
    "data-name": "Path 38829",
    d: "M11.814,37.939l3.7,3.516,3.807-3.62,3.873,3.683,3.782-3.595L30.74,41.5l4.016-3.82,3.37,3.384V6.561H7.988v34.79Z",
    transform: "translate(1046.461 969.68)",
    fill: "#f5f6f6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38830",
    "data-name": "Path 38830",
    d: "M26.5,11.088H10.72a1.094,1.094,0,1,1,0-2.188H26.5a1.094,1.094,0,0,1,0,2.188",
    transform: "translate(1049.237 972.945)",
    fill: "#e0e1e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38831",
    "data-name": "Path 38831",
    d: "M21.782,15.277H10.72a1.094,1.094,0,1,1,0-2.188H21.782a1.094,1.094,0,0,1,0,2.188",
    transform: "translate(1049.236 975.62)",
    fill: "#e0e1e3"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 1043.52, 967.26)",
    filter: "url(#Path_38832)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38832-2",
    "data-name": "Path 38832",
    d: "M24.574,21.065a3.338,3.338,0,1,1-3.338-3.338,3.338,3.338,0,0,1,3.338,3.338",
    transform: "translate(14.1 -5.39)",
    fill: "#56aa1c"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewinvoice);
export default __webpack_public_path__ + "static/media/New invoice.6e8cb5263bc5fac36fce323a417e6082.svg";
export { ForwardRef as ReactComponent };